<template>
  <UPage class="bg-workbook-white">
    <UPageBody>
    <UContainer class="mt-30 md:mt-0">      
      <ContentRenderer v-if="page" :value="page" />      
    </UContainer>
    </UPageBody>   
  </UPage>
</template>

<script setup lang="ts">

const route = useRoute()

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('pages').path(route.path).first()
})

useContentSeo(page)


</script>
